import { MDCChipSet } from '@material/chips'

export default {
  setup() {
    this.chip = new MDCChipSet(this.el) // document.querySelector('.mdc-evolution-chip-set')
  },
  destroy() {
    this.chip?.destroy()
    this.chip = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
